import type { SiteApiCurrency } from '@parlaygames/site-api';

export const getSymbol = (position: string, symbol: string) =>
    position === 'L' ? [symbol, ''] : ['', symbol];

export const getIncrementalMax = (value: number, increment: number) =>
    Math.ceil(value / increment) * increment;

export const fixedSectionFormatter = (
    value: string,
    separator: string,
    sections: number
) => {
    const { length } = value;
    const padSize = getIncrementalMax(length, sections);
    const padded = ' '.repeat(Math.max(0, padSize - length)) + value;
    return padded
        .replace(new RegExp(`(.{${sections}})(?=.)`, 'g'), '$1' + separator)
        .trim();
};

export const formatCurrency = (
    value: number,
    currency?: Partial<SiteApiCurrency>
) => {
    const {
        decimalPrec: precision = 2,
        sep: centSeparator = '.',
        symbol = '',
        pos: position = 'L',
        thousandSep: thousandSeparator = ',',
        centsSym: centSymbol = '',
        centsPos: centPosition = 'R',
    } = currency || {};

    // We need to enforce floated precision value check
    // to ensure that we don't render negative zeroes.
    // Check out the Math.sign() return values as a reference:
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/sign#return_value
    // e.g. -0.001 resolves to -0.00 if the precision=2
    const sign = parseFloat(value.toFixed(precision)) < 0 ? '-' : '';

    const [integer, decimal = ''] = Math.abs(value)
        .toFixed(precision)
        .split('.');

    const isDecimal = integer === '0' && parseInt(decimal, 10);

    let left = '';
    let right = '';
    let formatted = '';

    if (isDecimal && centSymbol) {
        [left, right] = getSymbol(centPosition, centSymbol);
        formatted = decimal;
    } else {
        [left, right] = getSymbol(position, symbol);

        const sectioned = fixedSectionFormatter(integer, thousandSeparator, 3);

        formatted =
            precision > 0
                ? [sectioned, decimal].join(centSeparator)
                : sectioned;
    }

    return sign + left + formatted + right;
};
